import { RG_TYPE } from '../../types/rg-type.js';

const DefaultFacade = {
    type: RG_TYPE.Facade,
    size: [6, 3, 0.1],
    anchor: [0.5, 0, 0.5],
    name: 'facade',
    color: '#C3B9AD',
    children: []
};

export { DefaultFacade };
//# sourceMappingURL=default-facade.js.map
